module.exports = "/images/ny-street-4.jpg";